import { toZonedTime } from 'date-fns-tz';

const TIMEZONE = 'America/Toronto';

export const slotFinder = (masseuse, slots) => {
  // Get current time in Toronto timezone for comparison
  const nowInToronto = toZonedTime(new Date(), TIMEZONE);

  // Filter all slots for the specific masseuse AND exclude past slots
  const masseuseSlots = slots?.filter((slot) => {
    if (slot.masseuse !== masseuse) return false;
    const slotTime = toZonedTime(slot.start_time, TIMEZONE);
    return slotTime > nowInToronto;
  });

  if (!masseuseSlots || masseuseSlots.length === 0) {
    return null;
  }

  // Find the earliest upcoming slot by comparing start_time
  const earliestSlot = masseuseSlots.reduce((earliest, current) => {
    const earliestTime = toZonedTime(earliest.start_time, TIMEZONE);
    const currentTime = toZonedTime(current.start_time, TIMEZONE);
    return currentTime < earliestTime ? current : earliest;
  });

  return earliestSlot;
};
